var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrammar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF68A5"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF0099"
    },
    d: "M259.681,511.953c133.657-1.886,242.532-106.186,251.681-237.966L349.125,111.751l-184.581,185.9 l22.308,22.311L235,377.842l-48.148,61.282L259.681,511.953z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD00"
    },
    d: "M256,72.875l-14.318,289.312l83.466-14.318v-32.721C362.28,292.025,387,250.84,387,203.875 C387,131.526,328.349,72.875,256,72.875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFED94"
    },
    d: "M256,72.875c-72.349,0-131,58.651-131,131c0,46.965,24.72,88.149,61.852,111.273v32.721L256,362.187 V72.875L256,72.875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6283A3"
    },
    d: "M352.816,214.605v-21.46h-24.26c-1.799-12.222-6.623-23.473-13.686-32.965l17.177-17.177 l-15.174-15.174l-17.177,17.177c-9.492-7.064-20.743-11.887-32.966-13.687v-24.26H256v44.932c28.608,0,51.883,23.275,51.883,51.883 c0,28.609-23.275,51.884-51.883,51.884v44.932h10.73v-24.26c12.222-1.8,23.474-6.623,32.966-13.687l17.177,17.177l15.174-15.174 l-17.177-17.177c7.064-9.492,11.887-20.743,13.686-32.965h24.26V214.605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9ABADB"
    },
    d: "M256,255.759c-28.609,0-51.883-23.275-51.883-51.884c0-28.608,23.275-51.883,51.883-51.883l0,0 V107.06h-10.73v24.26c-12.222,1.8-23.474,6.623-32.966,13.687l-17.176-17.176l-15.174,15.174l17.176,17.176 c-7.064,9.492-11.887,20.743-13.686,32.965h-24.26v21.46h24.26c1.8,12.222,6.623,23.474,13.687,32.966l-17.176,17.177l15.174,15.174 l17.176-17.176c9.492,7.064,20.743,11.887,32.966,13.687v24.26H256V255.759L256,255.759z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1E8FF"
    },
    points: "325.148,393.497 325.148,347.869 256,347.869 241.682,407.815 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5FF"
    },
    points: "186.852,393.497 256,407.815 256,347.869 186.852,347.869 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9ABADB"
    },
    points: "256,439.125 325.148,439.125 325.148,393.497 256,393.497 241.682,416.311 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.85,
    y: 393.5,
    style: {
      fill: "#D1E8FF"
    },
    width: 69.15,
    height: 45.628
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrammar);
export default __webpack_public_path__ + "static/media/grammar.04985a146efcfd510c24382c0f211c8f.svg";
export { ForwardRef as ReactComponent };